<div class="bc-top-header-filters flex align-items-center gap-3">
  <button
    class="regions-filter relative regions-multiselect"
    #regionsButton
    (click)="openRegions(multiSelectRegions)"
    [ngClass]="{ active: regionsActive() === 'regions' }"
  >
    <div class="flex align-items-center gap-2 w-full">
      <div class="flex flex-column align-items-start">
        <span class="label label-small-regular">Regions</span>
        @if (selectedRegions.length > 0) {
          <div class="value webkit-box-one-line label-large-medium">
            {{
              selectedRegions.length === 1
                ? selectedRegions[0].name
                : selectedRegions[0].name + " +" + selectedRegions.length
            }}
          </div>
        } @else {
          <div class="value white-space-nowrap label-large-medium">
            Select regions
          </div>
        }
      </div>
      <em class="ml-auto icon-caret-down"></em>
    </div>
    <p-multiSelect
      #multiSelectRegions
      appAdjustDropdownHeight
      (onChange)="onRegionChange()"
      [options]="regions()"
      (onPanelShow)="regionsActive.set('regions')"
      (onPanelHide)="regionsActive.set(null)"
      [placeholder]="'Select items'"
      [(ngModel)]="selectedRegions"
      [optionLabel]="'name'"
      [disabled]="false"
      [showClear]="false"
      [filter]="true"
      [selectAll]="false"
      [filterPlaceHolder]="'Search'"
      [appendTo]="regionsButton"
      [virtualScroll]="true"
      [virtualScrollItemSize]="33"
      class="multi-select"
      [styleClass]="'hidden-multiselect'"
      [overlayOptions]="{ styleClass: 'multiselect-overlay-filter-position' }"
      (ngModelChange)="regionsChange(selectedRegions)"
    >
    </p-multiSelect>
  </button>
  <button
    class="locations-filter relative"
    #locationsButton
    (click)="openRegions(multiSelectLocation)"
    [ngClass]="{ active: locationsActive() === 'locations' }"
  >
    <div class="flex align-items-center gap-2 w-full">
      <div class="flex flex-column align-items-start">
        <span class="label label-small-regular">Locations</span>
        @if (selectedLocations.length > 0) {
          <div class="value webkit-box-one-line label-large-medium">
            {{
              selectedLocations.length === 1
                ? selectedLocations[0].name
                : selectedLocations[0].name + " +" + selectedLocations.length
            }}
          </div>
        } @else {
          <div class="value white-space-nowrap label-large-medium">
            Select locations
          </div>
        }
      </div>
      <em class="ml-auto icon-caret-down"></em>
    </div>
    <p-multiSelect
      #multiSelectLocation
      appAdjustDropdownHeight
      (onChange)="onLocationChange()"
      (onPanelShow)="locationsActive.set('locations')"
      (onPanelHide)="locationsActive.set(null)"
      [options]="locations() | locationsFilterPipe: selectedRegions"
      [placeholder]="'Select items'"
      [(ngModel)]="selectedLocations"
      [optionLabel]="'name'"
      [disabled]="false"
      [showClear]="false"
      [filter]="true"
      [selectAll]="false"
      [filterPlaceHolder]="'Search'"
      [appendTo]="locationsButton"
      [virtualScroll]="true"
      [virtualScrollItemSize]="33"
      class="multi-select"
      [styleClass]="'hidden-multiselect'"
      [overlayOptions]="{ styleClass: 'multiselect-overlay-filter-position' }"
      (ngModelChange)="locationsChange(selectedLocations)"
    >
    </p-multiSelect>
  </button>
</div>
